import * as Types from 'src/types/membotDomain';
import { toCamelCaseDeep } from 'src/utils/transform';
import MemriseApi from '../MemriseApi';
import * as Schema from './schema';

class MembotApiClass extends MemriseApi {
  constructor() {
    super({ endpointPrefix: '/membot' });
  }

  public async getMissions(languagePairId: number): Promise<Types.MissionsResponse> {
    const response = await this.get<Schema.MissionsResponse>(`/${languagePairId}/missions/`);
    return toCamelCaseDeep(response);
  }
}

export const MembotApi = new MembotApiClass();
